import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { PlusIcon } from 'lucide-react';
import { Toolbar } from '@/shared/components/custom/toolbar';
import { FiltersPopover } from '@/shared/components/custom/filters-popover';
import { FloatingLabelInput } from '@/shared/components/custom/form-field/FloatingLabelInput';

interface ClientsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  activeFiltersCount: number;
  onResetFilters: () => void;
  onCreateClick: () => void;
}

export function ClientsToolbar({
  search,
  onSearchChange,
  activeFiltersCount,
  onResetFilters,
  onCreateClick,
}: ClientsToolbarProps) {
  const { t } = useTranslation('clients');

  return (
    <Toolbar className="pt-0">
      <Toolbar.Info title={t('page.title')} description={t('page.subtitle')} />
      <Toolbar.Actions>
        <FiltersPopover activeCount={activeFiltersCount} label={t('toolbar.filters')}>
          <FiltersPopover.Content>
            <FloatingLabelInput
              id="clients-search"
              label={t('toolbar.search')}
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              hasValue={!!search}
              data-testid="clients-search-input"
            />
            {activeFiltersCount > 0 && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onResetFilters}
                className="w-full"
                data-testid="clients-filters-reset"
              >
                {t('toolbar.reset')}
              </Button>
            )}
          </FiltersPopover.Content>
        </FiltersPopover>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="icon"
              variant="default"
              onClick={onCreateClick}
              aria-label={t('toolbar.create')}
              data-testid="clients-create-button"
            >
              <PlusIcon className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('toolbar.create')}</TooltipContent>
        </Tooltip>
      </Toolbar.Actions>
    </Toolbar>
  );
}
